import { UserForm } from "components/forms/UserForm"
import { useAppDispatch, useAppSelector } from "hooks/storeHooks"
import { useCallback, useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { tintVTOService } from "services/tintvto"
import { UserData } from "types"
import { clearProductSlice } from "store/product/productSlice"
import { clearUserInfo } from "store/user/userSlice"
import { BaseHeaderLayout, Box, Button, ContentLayout, Link } from "@strapi/design-system"
import { ArrowLeft, Exit } from "@strapi/icons"
import { useAlert } from "providers/AlertProvider"

export const UserSettingsPage = () => {
  const { t } = useTranslation()
  const { showAlert } = useAlert()
  const userInfo = useAppSelector((state) => state.user.userInfo)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(false)
  const [userData, setUserData] = useState<UserData>({
    username: userInfo.username,
    password: "",
    group: null,
    merchantId: userInfo.merchantId ?? "",
    integrationType: userInfo.integrationType,
  })

  const onLogout = useCallback(() => {
    dispatch(clearProductSlice())
    dispatch(clearUserInfo())
    tintVTOService.logout()
    navigate("/login")
  }, [navigate, dispatch])

  const handleSave = useCallback(async () => {
    setLoading(true)
    const response = await tintVTOService.updateUser({
      username: userData.username,
      password: userData.password,
    })
    const error = response.errors ? response.errors[0] : false

    showAlert({
      error: !!error,
      text: error ? error.message : t("userSettingsPage.passwordChanged"),
    })
    setLoading(false)
  }, [userData, showAlert, t])

  return (
    <Box>
      <BaseHeaderLayout
        title={t("userSettingsPage.userSettings")}
        as={"h1"}
        navigationAction={
          <Link startIcon={<ArrowLeft />} to={`/products`}>
            {t("userSettingsPage.backToProducts")}
          </Link>
        }
        primaryAction={
          <Button startIcon={<Exit />} variant="danger" onClick={onLogout}>
            {t("userSettingsPage.logout")}
          </Button>
        }
      />

      <ContentLayout>
        <UserForm
          userData={userData}
          onChange={(data) => setUserData(data)}
          loading={loading}
          handleSave={handleSave}
          cancelLink="/products"
        />
      </ContentLayout>
    </Box>
  )
}
